import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

type Props = {
  images: string[];
};

export default function ImageSlider({ images }: Props) {
  return (
    <div className="h-full w-full relative">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        className="h-full w-full"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="!h-[100dvh] w-full inline-block">
              <img
                src={image}
                className="absolute inset-0 h-full w-full scale-110 object-cover blur-3xl brightness-75"
                aria-hidden
              />

              <div className="absolute inset-0 bg-white/5 backdrop-blur-md" />

              <img src={image} className="relative block h-[100dvh] w-full object-cover" alt="" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
